import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ComingSoonContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: ${({ theme }) => theme.spacing.xxl} 0;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const Subtitle = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.xl};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

const Description = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

const HomeLink = styled(Link)`
  display: inline-block;
  padding: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.lg};
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  border-radius: 4px;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSizes.md};
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.info};
  }
`;

const NotNow: React.FC = () => {
  return (
    <ComingSoonContainer>
      <Title>준비 중인 페이지</Title>
      <Subtitle>곧 오픈 예정입니다</Subtitle>
      <Description>
        현재 페이지는 준비 중이며, 빠른 시일 내에 서비스를 제공해 드리겠습니다.
      </Description>
      <HomeLink to="/">메인 페이지로 돌아가기</HomeLink>
    </ComingSoonContainer>
  );
};

export default NotNow; 